export const academicTermsKeys = {
  programPurseAcademicTerms: (programId: number, purseId: number) => [
    'academic_terms',
    programId,
    purseId,
  ],
  updateProgramPurseAcademicTerm: (
    programId: number,
    purseId: number,
    academicTermId: number
  ) => ['academic_terms', programId, purseId, academicTermId],
}
